<script setup lang="ts">
import { TooltipContent as RekaTooltipContent } from "reka-ui"
import { twMerge } from "tailwind-merge"

const props = defineProps<{
  class?: string
}>()
</script>
<template>
  <RekaTooltipContent
    :class="
      twMerge(
        'TooltipContent z-50 max-w-52 rounded-md bg-zinc-900 px-2.5 py-1.5 text-xs text-zinc-200 shadow-xs select-none md:max-w-sm',
        props.class,
      )
    "
  >
    <slot />
  </RekaTooltipContent>
</template>
<style scoped>
:deep(.TooltipContent[data-side="top"]) {
  animation: slideDownAndFade 0.2s ease-out;
}

:deep(.TooltipContent[data-side="bottom"]) {
  animation: slideUpAndFade 0.2s ease-out;
}

:deep(.TooltipContent[data-side="left"]) {
  animation: slideRightAndFade 0.2s ease-out;
}

:deep(.TooltipContent[data-side="right"]) {
  animation: slideLeftAndFade 0.2s ease-out;
}

@keyframes slideDownAndFade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUpAndFade {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideLeftAndFade {
  from {
    opacity: 0;
    transform: translateX(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideRightAndFade {
  from {
    opacity: 0;
    transform: translateX(4px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
